import React from 'react'
import { Skeleton, Stack } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  container: {
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.shades.shade03}`,
    marginBottom: theme.spacing(3),
  },
  bottomSkeletonShape: {
    borderBottomLeftRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius,
  },
}))

/**
 * Component for displaying assign tariff form skeleton on isLoading state
 */
export const AssignTariffSkeleton = (): JSX.Element => {
  const { classes } = useStyles()

  return (
    <>
      <Stack my={3}>
        <Skeleton variant="rounded" height={30} width={120} />
      </Stack>
      <Stack className={classes.container}>
        <Skeleton variant="rounded" height={30} width={'90%'} sx={{ margin: 3 }} />
        <Skeleton variant="rectangular" height={30} className={classes.bottomSkeletonShape} />
      </Stack>
      <Stack className={classes.container}>
        <Skeleton variant="rounded" height={30} width={'90%'} sx={{ margin: 3 }} />
        <Skeleton variant="rectangular" height={30} className={classes.bottomSkeletonShape} />
      </Stack>
    </>
  )
}
